module.exports = __webpack_public_path__ + "assets/img/problem.1870b3a7.png";